@if (pages.length > 0) {
  <div class="d-flex align-items-center justify-content-center fs-7">
    <ul class="pagination px-0">
      <li
        tabindex="0"
        (click)="prev()"
        (keydown.enter)="prev()"
      >
        <i class="icon-chevron-start fs-4"></i>
      </li>

      @if (activePage - 3 >= 1) {
        <li tabindex="0" (click)="page(1)" (keydown.enter)="page(1)">1</li>
      }

      @if (activePage - 3 > 1) {
        <li>...</li>
      }

      @if (pages[activePage - 3]) {
        <li tabindex="0" (click)="page(pages[activePage - 3])" (keydown.enter)="page(pages[activePage - 3])">
          {{ pages[activePage - 3] }}
        </li>
      }

      @if (pages[activePage - 2]) {
        <li tabindex="0" (click)="page(pages[activePage - 2])" (keydown.enter)="page(pages[activePage - 2])">
          {{ pages[activePage - 2] }}
        </li>
      }

      <li class="active">{{ pages[activePage - 1] }}</li>

      @if (pages[activePage]) {
        <li tabindex="0" (click)="page(pages[activePage])" (keydown.enter)="page(pages[activePage])">
          {{ pages[activePage] }}
        </li>
      }

      @if (pages[activePage + 1]) {
        <li tabindex="0" (click)="page(pages[activePage + 1])" (keydown.enter)="page(pages[activePage + 1])">
          {{ pages[activePage + 1] }}
        </li>
      }

      @if (activePage + 3 < pages.length) {
        <li>...</li>
      }

      @if (activePage + 3 <= pages.length) {
        <li tabindex="0" (click)="page(pages.length)" (keydown.enter)="page(pages.length)">
          {{ pages.length }}
        </li>
      }

      <li
        tabindex="0"
        (click)="next()"
        (keydown.enter)="next()"
      >
        <i class="icon-chevron-end fs-4"></i>
      </li>
    </ul>

    @if (advanced) {
      <div class="d-flex align-items-center">
        <span class="col">{{ "GoTo" | translate }} : </span>
        <input
          class="form-control text-center px-1 py-2 mx-1"
          [class.border-danger]="p > pages.length || p === undefined || p < 1"
          [(ngModel)]="p"
          (keydown)="jumpToPage($event)"
          style="width: 60px;"
          type="text"
        />
        <button
          class="btn btn-link-primary"
          (click)="jumpToPageBlur()"
        >
          {{ "Go" | translate }}
          <i class="icon-chevron-end  fs-4 ms-1"></i>
        </button>
      </div>
    }
  </div>
}
